import TableData from "./TableData";;
import ListData from "./ListData";
import Filter from "./Filter";

const inAppSharesComponents = {
  Filter,
  TableData,
  ListData,
}

export default inAppSharesComponents;